import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { Creators as DialogCreators } from "modules/dialog/model"
import { Creators as notificationsCreators } from "modules/notifications/model"
import { getPeriodOrStartAndEndDates } from "selectors/queryString/dates"
import { getOnly } from "modules/factor-trends/selectors"
import { getSelectedViews, getFactorCategory } from "modules/factor-trends/selectors/factors"
import { getStartDate, getEndDate, getSelectedDate, getModelCurrentDate, getModelFactorsStartDate, getDatesAdjusted } from "modules/factor-trends/selectors/dates"
import { getSelectedModelId } from "./selectors"
import { getOptions, getSelectedOption } from "./selectors/options"
import { getFilteredData, getCategoryItemsSubset, getDriftArrows } from "./selectors/data"
import { getAvailableSelectViewFactors } from "./selectors/views"
import { getFileName } from "./selectors/file"
import { getFirstPerformanceDate } from "./selectors/performance"
import withOutletContext from "hocs/withOutletContext"

export default withOutletContext(createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    accountId: state.global.selected.accountId,
    modelId: getSelectedModelId(state, props),
    startDate: getStartDate(state),
    endDate: getEndDate(state),
    selectedDate: getSelectedDate(state),
    fetchStartDate: getStartDate(state),
  }),
  required: ["account", "modelId"],
  data: [{
    resource: "factorTrendsPerformance",
    url: ({ modelId, endDate, fetchStartDate }) => {
      if (!endDate || !fetchStartDate) return null

      return {
        id: `factorTrends-performance-${modelId}${fetchStartDate}${endDate}`,
        query: `query ($modelId: String!, $from: Date!, $to: Date!) {
          model (id: $modelId) {
            factors{
              id
              name
              category
              performance(from:$from, to:$to) {
                date
                percentPriceChangeCumulative
                normalizedReturn
              }
            }
          }
        }`,
        variables: {
          modelId,
          from: fetchStartDate,
          to: endDate,
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    ...state.modules.factorTrendsPerformance,
    earliestDate: getModelFactorsStartDate(state),
    latestDate: getModelCurrentDate(state),
    firstDate: getFirstPerformanceDate(state),
    data: getFilteredData(state),
    items: getCategoryItemsSubset(state),
    options: getOptions(state),
    fileName: getFileName(state, props),
    period: getPeriodOrStartAndEndDates(state),
    selectedOption: getSelectedOption(state),
    factorCategory: getFactorCategory(state),
    datesAdjusted: getDatesAdjusted(state),
    selectedViews: getSelectedViews(state),
    availableSelectViewFactors: getAvailableSelectViewFactors(state),
    driftArrows: getDriftArrows(state),
    only: getOnly(state),
  }),
  actions: {
    ...Creators,
    addNotification: notificationsCreators.add,
    openDialog: DialogCreators.open,
  },
}))
